import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { Collapse } from 'react-collapse'
import clsx from 'clsx'

function Card({ children, title }) {
  const [isOpened, setIsOpened] = useState(true)
  const [isFullyClosed, setIsFullyClosed] = useState(false)

  const handleOnRest = useCallback(
    (update) => {
      setIsFullyClosed(update.isFullyClosed)
    },
    [setIsFullyClosed],
  )

  return (
    <div
      className={clsx(
        'et_pb_toggle',
        isFullyClosed ? 'et_pb_toggle_close' : 'et_pb_toggle_open',
      )}
    >
      <div
        role="button"
        onClick={() => setIsOpened(!isOpened)}
        onKeyPress={(event) => event.code === 'Enter' && setIsOpened(!isOpened)}
        tabIndex="0"
      >
        <h5 className="et_pb_toggle_title">{title}</h5>
      </div>
      <Collapse isOpened={isOpened} onRest={handleOnRest}>
        <div className="et_pb_toggle_content clearfix">{children}</div>
      </Collapse>
    </div>
  )
}

Card.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

export default Card
